

function Home() {
    return (
        <div className='home_s1'>
            <h1>NEOH</h1>
            <p>The collection built by and runby ‘frenify’. Together we are strong than ever.</p>
            
        </div>
    )
}

export default Home;